/*
 * Generated on 11/29/2022, 9:24:44 AM
 * Do not edit this file, any changes will be overwritten
 */

"use strict";

updateFileInputs();
$(function () {
  $('a.popup').click(function (e) {
    e.preventDefault();
    width = $(this).data('popup-width') || 800;
    height = $(this).data('popup-height') || 600;
    popup($(this).attr('href'), width, height);
  });
  $(document).on('click', '.confirm', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    showConfirm({
      text: $(this).data('confirm'),
      textYes: $(this).data('text-yes'),
      textNo: $(this).data('text-no'),
      urlYes: $(this).attr('href'),
      onConfirm: $(this).data('onconfirm')
    });
  });
  $(document).on('click', 'a.show-alert', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    showAlert($(this).data('alert'));
  });
  $('#warning').fadeIn('slow');
  $('body').tooltip({
    selector: '[data-bs-toggle="tooltip"], i[title], a[title], abbr[title], div[title], span:not(.element-info-icon)[title]',
    offset: "0, 5",
    delay: 300
  });
  $('.dropdown-toggle').on('click', function (e) {
    if ($(this).attr('href') === '#') {
      e.preventDefault();
    }
  });
  $('.toggle-pass').on('mousedown', function (e) {
    e.preventDefault();
    var $passField = $(this).parent().find('input');
    var $icon = $(this).find('i');
    var newType = $passField.attr('type') === 'text' ? 'password' : 'text';
    $passField.attr('type', newType).focus();
    newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
  }).on('click', function (e) {
    e.preventDefault();
  });
  $('.search-form').each(function () {
    var $form = $(this).closest('form');
    $form.on('click', '.search-add-row', function (e) {
      e.preventDefault();
      var $table = $(this).closest('table');
      var $row = $(this).closest('tr');
      var $newRow = $row.clone();
      $newRow.find('input, select').val('');
      $newRow.appendTo($table);
    });
    $form.find('.search-reset').on('click', function () {
      $form.find('input[name=page]').val('1');
      $form.find('input[name=search_reset]').val('1');
      $form.find('input[type=text], select').val('');
      $form.find('input[type=checkbox], input[type=radio]').prop('checked', false);
      $form.trigger('submit');
    });
  }); // Disable submit buttons after submitting
  //$('form').submit(function() {
  //$(':submit').attr('disabled', true);
  //$(':submit').fadeTo('normal', 0.5);
  //});
});
$(function () {
  var $menu = $('.navbar-mainmenu').first();
  var $menuBody = $menu.find('.navbar-mainmenu-body');
  var $scrollLeft = $menu.find('.scroll-left');
  var $scrollRight = $menu.find('.scroll-right');

  function checkScrollBtns() {
    if ($menuBody.length === 0) {
      return;
    }

    var width = $menuBody.width();
    var scrollWidth = $menuBody.get(0).scrollWidth;
    var scrollLeft = Math.ceil($menuBody.get(0).scrollLeft);
    $scrollRight.toggleClass('show', width + scrollLeft < scrollWidth);
    $scrollLeft.toggleClass('show', scrollLeft > 0);
  }

  function scrollMenu(offset) {
    $menuBody.stop(false, false).animate({
      scrollLeft: $menuBody.get(0).scrollLeft + offset
    }, 300, function () {
      checkScrollBtns();
    });
  }

  $(window).on('resize init', function () {
    checkScrollBtns();
  }).trigger('init');
  $menu.on('mousewheel scroll touchmove', function () {
    checkScrollBtns();
  });
  $menu.on('touchend', function () {
    setTimeout(checkScrollBtns, 500);
  });
  $scrollLeft.on('click', function () {
    scrollMenu(-200);
  });
  $scrollRight.on('click', function () {
    scrollMenu(200);
  });
});
setInterval("keepAlive('lib/keepalive.php')", 5 * 60 * 1000);
$(document).ready(function () {
  // Append info popup to body if it doesn't exist
  // if ($('#element-info').length == 0) {
  // 	$('body').append('<div id="element-info"><div id="element-info-arrow"></div><div id="element-info-content"></div></div>');
  // }
  // Process .info-content divs inside the template
  $('.info-content').each(function () {
    var rel = $(this).attr('rel');
    addInfoIcon($(rel), QueryString.module, rel);
  }); // If needed, load the info icons

  if ($('[data-info]').length > 0) {
    loadInfoIcons();
  }

  $(document).on('click', function (e) {
    if ($(e.target).closest('#element-info').length === 0) {
      $('.info-active').trigger('click');
    }
  });
});

function loadInfoIcons() {
  var modules = [];
  $('[data-info]').each(function () {
    var module = $(this).data('module');

    if (module === undefined) {
      module = QueryString.module;
      $(this).attr('data-module', module);
    }

    if (modules.indexOf(module) < 0) {
      modules.push(module);
    }
  });
  $.each(modules, function (key, module) {
    $.get('lib/infotext.php?module=' + module.toLowerCase(), function (data) {
      $.each(data.split(','), function (i, field) {
        $('[data-info="' + field + '"][data-module="' + module + '"]').each(function () {
          addInfoIcon($(this), module, field);
        });
      });
    });
  });
}

function addInfoIcon($element, module, field) {
  if ($element.length == 0) {
    return;
  }

  if ($element.parent().find('.element-info-icon').length > 0) {
    return;
  }

  var $icon = $('<span class="element-info-icon" rel="' + field + '" data-module="' + module + '">' + '<i class="fa fa-info-circle"></i></span>');
  $icon.on('click', function (e) {
    e.stopPropagation();
    toggleInfo($icon);
  });
  $element.parent().append($icon);
}

function toggleInfo($icon) {
  var $info = $('#element-info');
  var rel = $icon.attr('rel'); // var doc_width  = $(document).width();
  // var ele_pos    = $icon.offset();
  // var ele_width  = $icon.outerWidth();
  // var info_width = $info.width();
  // var info_left  = $info.position().left;
  // var info_top   = $info.position().top;

  var module = $icon.data('module'); // $('.info-active').not($icon).removeClass('info-active');
  // var ele_left   = ele_pos.left;
  // var ele_top    = ele_pos.top;
  // $info.stop(true, true).fadeOut('fast', function() {
  // 	var new_left = ele_left + ele_width + 5;
  // 	var new_top  = ele_top - 1;

  var info_id = rel; //
  // 	if (new_left > doc_width - info_width - 20) {
  // 		new_left = doc_width - info_width - 20;
  // 		new_top  += 2;
  // 	}
  //
  // 	if ($icon.hasClass('info-active')) {
  // 		$icon.removeClass('info-active');
  // 		return;
  // 	}
  //
  // 	$info.css({
  // 		width: info_width,
  // 		left: new_left,
  // 		top: new_top
  // 	});

  if ($(rel).length > 0) {
    // $info.fadeIn('fast');
    // $('#element-info-content').html($('.info-content[rel="' + rel + '"]').html());
    $icon.tooltip({
      offset: "0, 5",
      html: true,
      trigger: 'manual',
      title: $('.info-content[rel="' + rel + '"]').html()
    });
    $icon.tooltip('toggle');
  } else {
    $.get('lib/infotext.php?module=' + module.toLowerCase() + '&info_id=' + info_id, function (data) {
      // $info.fadeIn('fast');
      // $('#element-info-content').html(data);
      $icon.tooltip({
        offset: "0, 5",
        html: true,
        trigger: 'manual',
        title: data
      });
      $icon.tooltip('toggle');
    });
  } // $icon.addClass('info-active');
  // });

}
/**
 * Get parameter value from url
 */


if (typeof QueryString == 'undefined') {
  var QueryString = function () {
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("="); // If first entry with this name

      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = pair[1]; // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [query_string[pair[0]], pair[1]];
        query_string[pair[0]] = arr; // If third or later entry with this name
      } else {
        query_string[pair[0]].push(pair[1]);
      }
    }

    return query_string;
  }();
}